// extracted by mini-css-extract-plugin
export default {"switcherContainer":"styles_switcherContainer__gDA0U","responsive":"styles_responsive__MchYU","active":"styles_active__6Htk7","inActive":"styles_inActive__wnm8K"};